import { normalize } from 'normalizr';

import * as entities from 'modules/processes/data/entities';

import { notify } from 'utils/reduxUtils';

import {
  addOnSchema,
  processSchema,
  profitItemSchema,
  discountSchema,
} from './entities';

// type Types = {
//   INIT: 'processes/detailsPage/INIT',

//   UPDATE_PROCESS_REQUEST: 'processes/detailsPage/UPDATE_PROCESS_REQUEST',
//   UPDATE_PROCESS_SUCCESS: 'processes/detailsPage/UPDATE_PROCESS_SUCCESS',
//   UPDATE_PROCESS_ERROR: 'processes/detailsPage/UPDATE_PROCESS_ERROR',

//   CREATE_MATERIAL_REQUEST: 'processes/detailsPage/CREATE_MATERIAL_REQUEST',
//   CREATE_MATERIAL_SUCCESS: 'processes/detailsPage/CREATE_MATERIAL_SUCCESS',
//   CREATE_MATERIAL_ERROR: 'processes/detailsPage/CREATE_MATERIAL_ERROR',

//   UPDATE_MATERIAL_REQUEST: 'processes/detailsPage/UPDATE_MATERIAL_REQUEST',
//   UPDATE_MATERIAL_SUCCESS: 'processes/detailsPage/UPDATE_MATERIAL_SUCCESS',
//   UPDATE_MATERIAL_ERROR: 'processes/detailsPage/UPDATE_MATERIAL_ERROR',

//   DELETE_MATERIAL_REQUEST: 'processes/detailsPage/DELETE_MATERIAL_REQUEST',
//   DELETE_MATERIAL_SUCCESS: 'processes/detailsPage/DELETE_MATERIAL_SUCCESS',
//   DELETE_MATERIAL_ERROR: 'processes/detailsPage/DELETE_MATERIAL_ERROR',

//   CREATE_FINISH_REQUEST: 'processes/detailsPage/CREATE_FINISH_REQUEST',
//   CREATE_FINISH_SUCCESS: 'processes/detailsPage/CREATE_FINISH_SUCCESS',
//   CREATE_FINISH_ERROR: 'processes/detailsPage/CREATE_FINISH_ERROR',

//   UPDATE_FINISH_REQUEST: 'processes/detailsPage/UPDATE_FINISH_REQUEST',
//   UPDATE_FINISH_SUCCESS: 'processes/detailsPage/UPDATE_FINISH_SUCCESS',
//   UPDATE_FINISH_ERROR: 'processes/detailsPage/UPDATE_FINISH_ERROR',

//   DELETE_FINISH_REQUEST: 'processes/detailsPage/DELETE_FINISH_REQUEST',
//   DELETE_FINISH_SUCCESS: 'processes/detailsPage/DELETE_FINISH_SUCCESS',
//   DELETE_FINISH_ERROR: 'processes/detailsPage/DELETE_FINISH_ERROR',

//   ADD_OPERATIONS_OPEN_MODAL: 'processes/detailsPage/ADD_OPERATIONS_OPEN_MODAL',
//   ADD_OPERATIONS_CLOSE_MODAL: 'processes/detailsPage/ADD_OPERATIONS_CLOSE_MODAL',
//   ADD_OPERATIONS_REQUEST: 'processes/detailsPage/ADD_OPERATIONS_REQUEST',
//   ADD_OPERATIONS_SUCCESS: 'processes/detailsPage/ADD_OPERATIONS_SUCCESS',
//   ADD_OPERATIONS_ERROR: 'processes/detailsPage/ADD_OPERATIONS_ERROR',

//   ADD_MATERIALS_OPEN_MODAL: 'processes/detailsPage/ADD_MATERIALS_OPEN_MODAL',
//   ADD_MATERIALS_CLOSE_MODAL: 'processes/detailsPage/ADD_MATERIALS_CLOSE_MODAL',
//   ADD_MATERIALS_REQUEST: 'processes/detailsPage/ADD_MATERIALS_REQUEST',
//   ADD_MATERIALS_SUCCESS: 'processes/detailsPage/ADD_MATERIALS_SUCCESS',
//   ADD_MATERIALS_ERROR: 'processes/detailsPage/ADD_MATERIALS_ERROR',

//   UPDATE_OP_FACTORY_REQUEST: 'processes/detailsPage/UPDATE_OP_FACTORY_REQUEST',
//   UPDATE_OP_FACTORY_SUCCESS: 'processes/detailsPage/UPDATE_OP_FACTORY_SUCCESS',
//   UPDATE_OP_FACTORY_ERROR: 'processes/detailsPage/UPDATE_OP_FACTORY_ERROR',

//   DELETE_PROCESS_ERROR: 'processes/detailsPage/DELETE_PROCESS_ERROR',
//   DELETE_PROCESS_REQUEST: 'processes/detailsPage/DELETE_PROCESS_REQUEST',

//   FORMULA_OPEN_MODAL: 'processes/detailsPage/FORMULA_OPEN_MODAL',
//   FORMULA_CLOSE_MODAL: 'processes/detailsPage/FORMULA_CLOSE_MODAL',
//   FORMULA_COMPILE_REQUEST: 'processes/detailsPage/FORMULA_COMPILE_REQUEST',
//   FORMULA_COMPILE_SUCCESS: 'processes/detailsPage/FORMULA_COMPILE_SUCCESS',
//   FORMULA_COMPILE_ERROR: 'processes/detailsPage/FORMULA_COMPILE_ERROR',
//   FORMULA_UPDATE_REQUEST: 'processes/detailsPage/FORMULA_UPDATE_REQUEST',
//   FORMULA_UPDATE_SUCCESS: 'processes/detailsPage/FORMULA_UPDATE_SUCCESS',
//   FORMULA_UPDATE_ERROR: 'processes/detailsPage/FORMULA_UPDATE_ERROR',
//   FORMULA_RESET_MESSAGE: 'processes/detailsPage/FORMULA_RESET_MESSAGE',
// };

export const types = {
  INIT: 'processes/detailsPage/INIT',

  UPDATE_PROCESS_REQUEST: 'processes/detailsPage/UPDATE_PROCESS_REQUEST',
  UPDATE_PROCESS_SUCCESS: 'processes/detailsPage/UPDATE_PROCESS_SUCCESS',
  UPDATE_PROCESS_ERROR: 'processes/detailsPage/UPDATE_PROCESS_ERROR',

  CREATE_MATERIAL_REQUEST: 'processes/detailsPage/CREATE_MATERIAL_REQUEST',
  CREATE_MATERIAL_SUCCESS: 'processes/detailsPage/CREATE_MATERIAL_SUCCESS',
  CREATE_MATERIAL_ERROR: 'processes/detailsPage/CREATE_MATERIAL_ERROR',

  UPDATE_MATERIAL_REQUEST: 'processes/detailsPage/UPDATE_MATERIAL_REQUEST',
  UPDATE_MATERIAL_SUCCESS: 'processes/detailsPage/UPDATE_MATERIAL_SUCCESS',
  UPDATE_MATERIAL_ERROR: 'processes/detailsPage/UPDATE_MATERIAL_ERROR',

  DELETE_MATERIAL_REQUEST: 'processes/detailsPage/DELETE_MATERIAL_REQUEST',
  DELETE_MATERIAL_SUCCESS: 'processes/detailsPage/DELETE_MATERIAL_SUCCESS',
  DELETE_MATERIAL_ERROR: 'processes/detailsPage/DELETE_MATERIAL_ERROR',

  CREATE_FINISH_REQUEST: 'processes/detailsPage/CREATE_FINISH_REQUEST',
  CREATE_FINISH_SUCCESS: 'processes/detailsPage/CREATE_FINISH_SUCCESS',
  CREATE_FINISH_ERROR: 'processes/detailsPage/CREATE_FINISH_ERROR',

  UPDATE_FINISH_REQUEST: 'processes/detailsPage/UPDATE_FINISH_REQUEST',
  UPDATE_FINISH_SUCCESS: 'processes/detailsPage/UPDATE_FINISH_SUCCESS',
  UPDATE_FINISH_ERROR: 'processes/detailsPage/UPDATE_FINISH_ERROR',

  DELETE_FINISH_REQUEST: 'processes/detailsPage/DELETE_FINISH_REQUEST',
  DELETE_FINISH_SUCCESS: 'processes/detailsPage/DELETE_FINISH_SUCCESS',
  DELETE_FINISH_ERROR: 'processes/detailsPage/DELETE_FINISH_ERROR',

  ADD_OPERATIONS_OPEN_MODAL: 'processes/detailsPage/ADD_OPERATIONS_OPEN_MODAL',
  ADD_OPERATIONS_CLOSE_MODAL:
    'processes/detailsPage/ADD_OPERATIONS_CLOSE_MODAL',
  ADD_OPERATIONS_REQUEST: 'processes/detailsPage/ADD_OPERATIONS_REQUEST',
  ADD_OPERATIONS_SUCCESS: 'processes/detailsPage/ADD_OPERATIONS_SUCCESS',
  ADD_OPERATIONS_ERROR: 'processes/detailsPage/ADD_OPERATIONS_ERROR',

  ADD_MATERIALS_OPEN_MODAL: 'processes/detailsPage/ADD_MATERIALS_OPEN_MODAL',
  ADD_MATERIALS_CLOSE_MODAL: 'processes/detailsPage/ADD_MATERIALS_CLOSE_MODAL',
  ADD_MATERIALS_REQUEST: 'processes/detailsPage/ADD_MATERIALS_REQUEST',
  ADD_MATERIALS_SUCCESS: 'processes/detailsPage/ADD_MATERIALS_SUCCESS',
  ADD_MATERIALS_ERROR: 'processes/detailsPage/ADD_MATERIALS_ERROR',

  UPDATE_OP_FACTORY_REQUEST: 'processes/detailsPage/UPDATE_OP_FACTORY_REQUEST',
  UPDATE_OP_FACTORY_SUCCESS: 'processes/detailsPage/UPDATE_OP_FACTORY_SUCCESS',
  UPDATE_OP_FACTORY_ERROR: 'processes/detailsPage/UPDATE_OP_FACTORY_ERROR',

  DELETE_PROCESS_ERROR: 'processes/detailsPage/DELETE_PROCESS_ERROR',
  DELETE_PROCESS_REQUEST: 'processes/detailsPage/DELETE_PROCESS_REQUEST',

  FORMULA_OPEN_MODAL: 'processes/detailsPage/FORMULA_OPEN_MODAL',
  FORMULA_CLOSE_MODAL: 'processes/detailsPage/FORMULA_CLOSE_MODAL',
  FORMULA_COMPILE_REQUEST: 'processes/detailsPage/FORMULA_COMPILE_REQUEST',
  FORMULA_COMPILE_SUCCESS: 'processes/detailsPage/FORMULA_COMPILE_SUCCESS',
  FORMULA_COMPILE_ERROR: 'processes/detailsPage/FORMULA_COMPILE_ERROR',
  FORMULA_UPDATE_REQUEST: 'processes/detailsPage/FORMULA_UPDATE_REQUEST',
  FORMULA_UPDATE_SUCCESS: 'processes/detailsPage/FORMULA_UPDATE_SUCCESS',
  FORMULA_UPDATE_ERROR: 'processes/detailsPage/FORMULA_UPDATE_ERROR',
  FORMULA_RESET_MESSAGE: 'processes/detailsPage/FORMULA_RESET_MESSAGE',

  ADD_ADD_ONS_OPEN_MODAL: 'processes/detailsPage/ADD_ADD_ONS_OPEN_MODAL',
  ADD_ADD_ONS_CLOSE_MODAL: 'processes/detailsPage/ADD_ADD_ONS_CLOSE_MODAL',
  ADD_ADD_ONS_REQUEST: 'processes/detailsPage/ADD_ADD_ONS_REQUEST',
  ADD_ADD_ONS_SUCCESS: 'processes/detailsPage/ADD_ADD_ONS_SUCCESS',
  ADD_ADD_ONS_ERROR: 'processes/detailsPage/ADD_ADD_ONS_ERROR',

  LOAD_ADD_ONS_ERROR: 'processes/detailsPage/LOAD_ADD_ONS_ERROR',
  LOAD_ADD_ONS_SUCCESS: 'processes/detailsPage/LOAD_ADD_ONS_SUCCESS',

  SEARCH_ADD_ONS_ERROR: 'processes/detailsPage/SEARCH_ADD_ONS_ERROR',
  SEARCH_ADD_ONS_REQUEST: 'processes/detailsPage/SEARCH_ADD_ONS_REQUEST',
  SEARCH_ADD_ONS_SUCCESS: 'processes/detailsPage/SEARCH_ADD_ONS_SUCCESS',

  ADD_PROFIT_ITEMS_OPEN_MODAL:
    'processes/detailsPage/ADD_PROFIT_ITEMS_OPEN_MODAL',
  ADD_PROFIT_ITEMS_CLOSE_MODAL:
    'processes/detailsPage/ADD_PROFIT_ITEMS_CLOSE_MODAL',
  ADD_PROFIT_ITEMS_REQUEST: 'processes/detailsPage/ADD_PROFIT_ITEMS_REQUEST',
  ADD_PROFIT_ITEMS_SUCCESS: 'processes/detailsPage/ADD_PROFIT_ITEMS_SUCCESS',
  ADD_PROFIT_ITEMS_ERROR: 'processes/detailsPage/ADD_PROFIT_ITEMS_ERROR',

  LOAD_PROFIT_ITEMS_ERROR: 'processes/detailsPage/LOAD_PROFIT_ITEMS_ERROR',
  LOAD_PROFIT_ITEMS_SUCCESS: 'processes/detailsPage/LOAD_PROFIT_ITEMS_SUCCESS',

  SEARCH_PROFIT_ITEMS_ERROR: 'processes/detailsPage/SEARCH_PROFIT_ITEMS_ERROR',
  SEARCH_PROFIT_ITEMS_REQUEST:
    'processes/detailsPage/SEARCH_PROFIT_ITEMS_REQUEST',
  SEARCH_PROFIT_ITEMS_SUCCESS:
    'processes/detailsPage/SEARCH_PROFIT_ITEMS_SUCCESS',

  ADD_DISCOUNTS_OPEN_MODAL: 'processes/detailsPage/ADD_DISCOUNTS_OPEN_MODAL',
  ADD_DISCOUNTS_CLOSE_MODAL: 'processes/detailsPage/ADD_DISCOUNTS_CLOSE_MODAL',
  ADD_DISCOUNTS_REQUEST: 'processes/detailsPage/ADD_DISCOUNTS_REQUEST',
  ADD_DISCOUNTS_SUCCESS: 'processes/detailsPage/ADD_DISCOUNTS_SUCCESS',
  ADD_DISCOUNTS_ERROR: 'processes/detailsPage/ADD_DISCOUNTS_ERROR',

  LOAD_DISCOUNTS_ERROR: 'processes/detailsPage/LOAD_DISCOUNTS_ERROR',
  LOAD_DISCOUNTS_SUCCESS: 'processes/detailsPage/LOAD_DISCOUNTS_SUCCESS',

  SEARCH_DISCOUNTS_ERROR: 'processes/detailsPage/SEARCH_DISCOUNTS_ERROR',
  SEARCH_DISCOUNTS_REQUEST: 'processes/detailsPage/SEARCH_DISCOUNTS_REQUEST',
  SEARCH_DISCOUNTS_SUCCESS: 'processes/detailsPage/SEARCH_DISCOUNTS_SUCCESS',
};

// export type InitAction = {
//   type: typeof types.INIT,
//   payload: NormalizedEntity,
// };
export const init = (payload) => ({
  type: types.INIT,
  payload: normalize(payload, processSchema),
});

// export type UpdateProcessRequestAction = {
//   type: typeof types.UPDATE_PROCESS_REQUEST,
//   payload: { processId: Id, data: $Shape<Process> },
// };
// export type UpdateProcessSuccessAction = {
//   type: typeof types.UPDATE_PROCESS_SUCCESS,
//   payload: NormalizedEntity,
// };
// export type UpdateProcessErrorAction = {
//   type: typeof types.UPDATE_PROCESS_ERROR,
//   payload: Object,
// };
export const updateProcess = {
  request: (processId, data) => ({
    type: types.UPDATE_PROCESS_REQUEST,
    payload: { processId, data },
  }),
  success: (payload) => ({
    type: types.UPDATE_PROCESS_SUCCESS,
    payload: normalize(payload, processSchema),
  }),
  error: (error) => ({
    type: types.UPDATE_PROCESS_ERROR,
    payload: error,
  }),
};

// export type CreateMaterialRequestAction = {
//   type: typeof types.CREATE_MATERIAL_REQUEST,
//   payload: { processId: Id, materialIds: Array<Id>, cb: (?Object) => void },
// };
// export type CreateMaterialSuccessAction = {
//   type: typeof types.CREATE_MATERIAL_SUCCESS,
//   payload: NormalizedArray & { processId: Id },
// };
// export type CreateMaterialErrorAction = {
//   type: typeof types.CREATE_MATERIAL_ERROR,
//   payload: Object,
// };
export const createMaterial = {
  request: (processId, materialIds, cb) => ({
    type: types.CREATE_MATERIAL_REQUEST,
    payload: { processId, materialIds, cb },
  }),
  success: (processId, payload) => ({
    type: types.CREATE_MATERIAL_SUCCESS,
    payload: {
      ...normalize(payload, [entities.processMaterialSchema]),
      processId,
    },
  }),
  error: (error) => ({
    type: types.CREATE_MATERIAL_ERROR,
    payload: error,
  }),
};

// export type UpdateMaterialRequestAction = {
//   type: typeof types.UPDATE_MATERIAL_REQUEST,
//   payload: { materialId: Id, data: $Shape<ProcessMaterial> },
// };
// export type UpdateMaterialSuccessAction = {
//   type: typeof types.UPDATE_MATERIAL_SUCCESS,
//   payload: NormalizedEntity,
// };
// export type UpdateMaterialErrorAction = {
//   type: typeof types.UPDATE_MATERIAL_ERROR,
//   payload: Object,
// };
export const updateMaterial = {
  request: (materialId, data) => ({
    type: types.UPDATE_MATERIAL_REQUEST,
    payload: { materialId, data },
  }),
  success: (payload) => ({
    type: types.UPDATE_MATERIAL_SUCCESS,
    payload: normalize(payload, entities.processMaterialSchema),
  }),
  error: (error) => ({
    type: types.UPDATE_MATERIAL_ERROR,
    payload: error,
  }),
};

// export type DeleteMaterialRequestAction = {
//   type: typeof types.DELETE_MATERIAL_REQUEST,
//   payload: { processId: Id, materialId: Id },
// };
// export type DeleteMaterialSuccessAction = {
//   type: typeof types.DELETE_MATERIAL_SUCCESS,
//   payload: { processId: Id, materialId: Id },
// };
// export type DeleteMaterialErrorAction = {
//   type: typeof types.DELETE_MATERIAL_ERROR,
//   payload: Object,
// };
export const deleteMaterial = {
  request: (processId, materialId) => ({
    type: types.DELETE_MATERIAL_REQUEST,
    payload: { processId, materialId },
  }),
  success: (processId, materialId) => ({
    type: types.DELETE_MATERIAL_SUCCESS,
    payload: { processId, materialId },
  }),
  error: (error) => ({
    type: types.DELETE_MATERIAL_ERROR,
    payload: error,
  }),
};

// export type CreateFinishRequestAction = {
//   type: typeof types.CREATE_FINISH_REQUEST,
//   payload: { processId: Id, finishIds: Array<Id>, cb: (?Object) => void },
// };
// export type CreateFinishSuccessAction = {
//   type: typeof types.CREATE_FINISH_SUCCESS,
//   payload: NormalizedArray & { processId: Id },
// };
// export type CreateFinishErrorAction = {
//   type: typeof types.CREATE_FINISH_ERROR,
//   payload: Object,
// };
export const createFinish = {
  request: (processId, finishIds, cb) => ({
    type: types.CREATE_FINISH_REQUEST,
    payload: { processId, finishIds, cb },
  }),
  success: (processId, payload) => ({
    type: types.CREATE_FINISH_SUCCESS,
    payload: {
      ...normalize(payload, [entities.processFinishSchema]),
      processId,
    },
  }),
  error: (error) => ({
    type: types.CREATE_FINISH_ERROR,
    payload: error,
  }),
};

// export type UpdateFinishRequestAction = {
//   type: typeof types.UPDATE_FINISH_REQUEST,
//   payload: { finishId: Id, data: $Shape<ProcessFinish> },
// };
// export type UpdateFinishSuccessAction = {
//   type: typeof types.UPDATE_FINISH_SUCCESS,
//   payload: NormalizedEntity,
// };
// export type UpdateFinishErrorAction = {
//   type: typeof types.UPDATE_FINISH_ERROR,
//   payload: Object,
// };
export const updateFinish = {
  request: (finishId, data) => ({
    type: types.UPDATE_FINISH_REQUEST,
    payload: { finishId, data },
  }),
  success: (payload) => ({
    type: types.UPDATE_FINISH_SUCCESS,
    payload: normalize(payload, entities.processFinishSchema),
  }),
  error: (error) => ({
    type: types.UPDATE_FINISH_ERROR,
    payload: error,
  }),
};

// export type DeleteFinishRequestAction = {
//   type: typeof types.DELETE_FINISH_REQUEST,
//   payload: { processId: Id, finishId: Id },
// };
// export type DeleteFinishSuccessAction = {
//   type: typeof types.DELETE_FINISH_SUCCESS,
//   payload: { processId: Id, finishId: Id },
// };
// export type DeleteFinishErrorAction = {
//   type: typeof types.DELETE_FINISH_ERROR,
//   payload: Object,
// };
export const deleteFinish = {
  request: (processId, finishId) => ({
    type: types.DELETE_FINISH_REQUEST,
    payload: { processId, finishId },
  }),
  success: (processId, finishId) => ({
    type: types.DELETE_FINISH_SUCCESS,
    payload: { processId, finishId },
  }),
  error: (error) => ({
    type: types.DELETE_FINISH_ERROR,
    payload: error,
  }),
};

// export type AddOperationsOpenModalAction = {
//   type: typeof types.ADD_OPERATIONS_OPEN_MODAL,
//   payload: { type: 'operations' | 'finishes' },
// };
// export type AddOperationsCloseModalAction = {
//   type: typeof types.ADD_OPERATIONS_CLOSE_MODAL,
// };

export const addOperations = {
  openModal: (payload) => ({
    type: types.ADD_OPERATIONS_OPEN_MODAL,
    payload,
  }),
  closeModal: () => ({
    type: types.ADD_OPERATIONS_CLOSE_MODAL,
  }),
  request: (payload) => ({
    type: types.ADD_OPERATIONS_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.ADD_OPERATIONS_SUCCESS,
    payload: normalize(payload, processSchema),
  }),
  error: (payload) => ({
    type: types.ADD_OPERATIONS_ERROR,
    payload,
  }),
};

// export type AddMaterialsOpenModalAction = {
//   type: typeof types.ADD_MATERIALS_OPEN_MODAL,
//   payload: { type: 'operations' | 'finishes' },
// };
// export type AddMaterialsCloseModalAction = {
//   type: typeof types.ADD_MATERIALS_CLOSE_MODAL,
// };

export const addMaterials = {
  openModal: (payload) => ({
    type: types.ADD_MATERIALS_OPEN_MODAL,
    payload,
  }),
  closeModal: () => ({
    type: types.ADD_MATERIALS_CLOSE_MODAL,
  }),
  request: (processId, supplierMaterialIds) => ({
    type: types.ADD_MATERIALS_REQUEST,
    payload: { processId, supplierMaterialIds },
  }),
  success: (payload) => ({
    type: types.ADD_MATERIALS_SUCCESS,
    payload: normalize(payload, processSchema),
  }),
  error: (payload) => ({
    type: types.ADD_MATERIALS_ERROR,
    payload,
  }),
};

// type DeleteErrorAction = {|
//   type: typeof types.DELETE_PROCESS_ERROR,
//   payload: Object,
// |};
// type DeleteRequestAction = {|
//   type: typeof types.DELETE_PROCESS_REQUEST,
//   payload: {| processId: Id |},
// |};
export const deleteProcess = {
  error: (error) => ({
    type: types.DELETE_PROCESS_ERROR,
    payload: error,
  }),
  request: () => ({
    type: types.DELETE_PROCESS_REQUEST,
  }),
};

export const formulaEdit = {
  openModal: () => ({
    type: types.FORMULA_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.FORMULA_CLOSE_MODAL,
  }),
  compileRequest: ({ formula }) => ({
    type: types.FORMULA_COMPILE_REQUEST,
    payload: { formula },
  }),
  compileSuccess: () => ({
    type: types.FORMULA_COMPILE_SUCCESS,
  }),
  compileError: ({ error }) => ({
    type: types.FORMULA_COMPILE_ERROR,
    payload: { error },
  }),
  updateRequest: ({ formula, revertedFrom }) => ({
    type: types.FORMULA_UPDATE_REQUEST,
    payload: { formula, revertedFrom },
  }),
  updateSuccess: ({ formula, processId }) => ({
    type: types.FORMULA_UPDATE_SUCCESS,
    payload: { formula, processId },
  }),
  updateError: ({ error }) => ({
    type: types.FORMULA_UPDATE_ERROR,
    payload: { error },
  }),
  resetFormulaMessage: () => ({
    type: types.FORMULA_RESET_MESSAGE,
  }),
};

export const addAddOns = {
  openModal: () => ({
    type: types.ADD_ADD_ONS_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.ADD_ADD_ONS_CLOSE_MODAL,
  }),
  request: ({ addOnDefTemplate }) => ({
    type: types.ADD_ADD_ONS_REQUEST,
    payload: { addOnDefTemplate },
  }),
  success: ({ process }) => ({
    type: types.ADD_ADD_ONS_SUCCESS,
    payload: normalize(process, processSchema),
  }),
  error: notify(
    (error) => ({
      type: types.ADD_ADD_ONS_ERROR,
      payload: error,
    }),
    'Failed to save add-ons',
  ),
};

export const searchAddOns = {
  error: notify(
    (error) => ({
      type: types.SEARCH_ADD_ONS_ERROR,
      payload: error,
    }),
    'Failed to load Add-Ons',
  ),
  request: ({ searchTerm }) => ({
    type: types.SEARCH_ADD_ONS_REQUEST,
    payload: { searchTerm },
  }),
  success: ({ addOns }) => ({
    type: types.SEARCH_ADD_ONS_SUCCESS,
    payload: normalize(addOns, [addOnSchema]),
  }),
};

export const loadAddOns = {
  error: notify(
    (error) => ({
      type: types.LOAD_ADD_ONS_ERROR,
      payload: error,
    }),
    'Failed to load Add-Ons',
  ),
  success: ({ addOns }) => ({
    type: types.LOAD_ADD_ONS_SUCCESS,
    payload: normalize(addOns, [addOnSchema]),
  }),
};

export const addProfitItems = {
  openModal: () => ({
    type: types.ADD_PROFIT_ITEMS_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.ADD_PROFIT_ITEMS_CLOSE_MODAL,
  }),
  request: ({ profitItemDefTemplate }) => ({
    type: types.ADD_PROFIT_ITEMS_REQUEST,
    payload: { profitItemDefTemplate },
  }),
  success: ({ process }) => ({
    type: types.ADD_PROFIT_ITEMS_SUCCESS,
    payload: normalize(process, processSchema),
  }),
  error: notify(
    (error) => ({
      type: types.ADD_PROFIT_ITEMS_ERROR,
      payload: error,
    }),
    'Failed to save Pricing Items',
  ),
};

export const searchProfitItems = {
  error: notify(
    (error) => ({
      type: types.SEARCH_PROFIT_ITEMS_ERROR,
      payload: error,
    }),
    'Failed to load Pricing Items',
  ),
  request: ({ searchTerm }) => ({
    type: types.SEARCH_PROFIT_ITEMS_REQUEST,
    payload: { searchTerm },
  }),
  success: ({ profitItems }) => ({
    type: types.SEARCH_PROFIT_ITEMS_SUCCESS,
    payload: normalize(profitItems, [profitItemSchema]),
  }),
};

export const loadProfitItems = {
  error: notify(
    (error) => ({
      type: types.LOAD_PROFIT_ITEMS_ERROR,
      payload: error,
    }),
    'Failed to load Pricing Items',
  ),
  success: ({ profitItems }) => ({
    type: types.LOAD_PROFIT_ITEMS_SUCCESS,
    payload: normalize(profitItems, [profitItemSchema]),
  }),
};

export const addDiscounts = {
  openModal: () => ({
    type: types.ADD_DISCOUNTS_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.ADD_DISCOUNTS_CLOSE_MODAL,
  }),
  request: ({ discountDefTemplate }) => ({
    type: types.ADD_DISCOUNTS_REQUEST,
    payload: { discountDefTemplate },
  }),
  success: ({ process }) => ({
    type: types.ADD_DISCOUNTS_SUCCESS,
    payload: normalize(process, processSchema),
  }),
  error: notify(
    (error) => ({
      type: types.ADD_DISCOUNTS_ERROR,
      payload: error,
    }),
    'Failed to save Discounts',
  ),
};

export const searchDiscounts = {
  error: notify(
    (error) => ({
      type: types.SEARCH_DISCOUNTS_ERROR,
      payload: error,
    }),
    'Failed to load Discounts',
  ),
  request: ({ searchTerm }) => ({
    type: types.SEARCH_DISCOUNTS_REQUEST,
    payload: { searchTerm },
  }),
  success: ({ discounts }) => ({
    type: types.SEARCH_DISCOUNTS_SUCCESS,
    payload: normalize(discounts, [discountSchema]),
  }),
};

export const loadDiscounts = {
  error: notify(
    (error) => ({
      type: types.LOAD_DISCOUNTS_ERROR,
      payload: error,
    }),
    'Failed to load Discounts',
  ),
  success: ({ discounts }) => ({
    type: types.LOAD_DISCOUNTS_SUCCESS,
    payload: normalize(discounts, [discountSchema]),
  }),
};

// export type Action =
//   | InitAction
//   | UpdateProcessRequestAction
//   | UpdateProcessSuccessAction
//   | UpdateProcessErrorAction
//   | CreateExpediteRequestAction
//   | CreateExpediteSuccessAction
//   | CreateExpediteErrorAction
//   | UpdateExpediteRequestAction
//   | UpdateExpediteSuccessAction
//   | UpdateExpediteErrorAction
//   | DeleteExpediteRequestAction
//   | DeleteExpediteSuccessAction
//   | DeleteExpediteErrorAction
//   | CreateMaterialRequestAction
//   | CreateMaterialSuccessAction
//   | CreateMaterialErrorAction
//   | UpdateMaterialRequestAction
//   | UpdateMaterialSuccessAction
//   | UpdateMaterialErrorAction
//   | DeleteMaterialRequestAction
//   | DeleteMaterialSuccessAction
//   | DeleteMaterialErrorAction
//   | CreateFinishRequestAction
//   | CreateFinishSuccessAction
//   | CreateFinishErrorAction
//   | UpdateFinishRequestAction
//   | UpdateFinishSuccessAction
//   | UpdateFinishErrorAction
//   | DeleteFinishRequestAction
//   | DeleteFinishSuccessAction
//   | DeleteFinishErrorAction
//   | AddOperationsOpenModalAction
//   | AddOperationsCloseModalAction;
